import {Component, HostListener, Injectable, OnDestroy} from '@angular/core';
import {NavigationEnd, Router, UrlSegment} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {PageStateService} from './shared/services/page-state.service';
import {NavigationService} from '../navigation/service/navigation.service';

const RouterData = {
    WITH_SECTION_NAV: 'withSectionNav'
};

@Component({
    selector: 'my-page-content',
    template: require('./page-content.component.html'),
    styles: [require('./page-content.component.scss')]
})
@Injectable()
export class PageContentComponent implements OnDestroy {

    @HostListener('window:beforeunload', ['$event'])
    beforeunloadHandler(event) {
        if (this._pageStateService.unsavedDataPresent()) {
            event.returnValue = this._navigationService.unsavedDataDiscardingConfirmationMessage();
        }
    }

    displayLeftNav: boolean = false;

    subscriptions: Subscription[] = [];

    private _previousUrl: string;

    constructor(private readonly _router: Router,
                private readonly _pageStateService: PageStateService,
                private readonly _navigationService: NavigationService) {
        this.subscriptions.push(_router.events
            .subscribe(event => {

                if (event instanceof NavigationEnd) {

                    this._refreshPageState();
                    this._refreshDisplayLeftNav();
                }
            }));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(it => it.unsubscribe());
    }

    private _refreshPageState() {
        let urlSegments: UrlSegment[] = [];

        let node = this._router.routerState.root;
        while (node) {
            urlSegments.push(...node.snapshot.url);

            node = node.firstChild;
        }

        const url = urlSegments.join('/');
        if (url !== this._previousUrl) {
            this._pageStateService.reset();
            this._previousUrl = url;
        }
    }

    private _refreshDisplayLeftNav() {
        let withSectionNav = true;

        let node = this._router.routerState.root;
        while (node) {
            const data = node.snapshot.data;
            if (data) {
                const value = data[RouterData.WITH_SECTION_NAV];
                if (value !== undefined) withSectionNav = value;
            }

            node = node.firstChild;
        }

        this.displayLeftNav = withSectionNav;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/page-content.component.ts